"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableCellComponent = TableCellComponent;
var jsx_runtime_1 = require("react/jsx-runtime");
function TableCellComponent(_a) {
    var columnRecord = _a.columnRecord, columnKey = _a.columnKey, rowActions = _a.rowActions, renderCellViews = _a.renderCellViews;
    var columnRecordKey = columnKey;
    var cellValue = columnRecord[columnRecordKey];
    if (columnRecordKey !== "actions") {
        var cellView = renderCellViews(cellValue, columnRecord).find(function (view) { return columnRecordKey === (view === null || view === void 0 ? void 0 : view.key); });
        if (cellView) {
            return cellView === null || cellView === void 0 ? void 0 : cellView.content;
        }
        else {
            return (0, jsx_runtime_1.jsx)("div", { className: "text-nowrap text-sm capitalize text-default-foreground", children: cellValue });
        }
    }
    else {
        if (!!rowActions) {
            var rowAction = rowActions(columnRecord);
            return (0, jsx_runtime_1.jsx)("div", { className: "flex items-center justify-end gap-2", children: rowAction.map(function (_a) {
                    var element = _a.element;
                    return element;
                }) });
        }
        return null;
    }
}
